// ClAlert's layout rules (the app's cl_alert.dart, the Alerts board): a
// 270 px card whose actions sit side by side, split by a 1 px hairline,
// unless there are more than two or a label won't fit its half of the row
// on one line. Each action pads 8 on either side, so a label gets
// (270 - 1) / 2 - 16 = 118.5 px, measured in the action's own font
// (17 px, 600 for the bold one).
export const ALERT_WIDTH = 270;
export const ALERT_ACTION_PAD = 8;
export const ALERT_LABEL_SLOT = (ALERT_WIDTH - 1) / 2 - 2 * ALERT_ACTION_PAD;

/**
 * Whether an alert's actions stack. `widths` are the labels' measured
 * widths in px, in the actions' order; before they are measured (null),
 * only the count decides.
 */
export function stackAlertActions(actions, widths = null) {
  const list = Array.isArray(actions) ? actions : [];
  if (list.length > 2) return true;
  if (!Array.isArray(widths)) return false;
  return widths.some((w) => Number(w) > ALERT_LABEL_SLOT);
}

/** Stacked, the last action goes on top and the first at the bottom (iOS). */
export function alertActionOrder(actions, stacked) {
  const list = Array.isArray(actions) ? actions : [];
  return stacked ? [...list].reverse() : list;
}
